<template>
  <span class="farb-square" :class="cls" :title="title">{{ label }}</span>
</template>

<script>
// Colour square for "Farbigkeit" (#31).
// Recognises 4/4 (4C), 4/1 (red+black), 1/1 (sw), Sonderfarben (orange).
// Falls back to a neutral grey square with the raw value as tooltip.

export default {
  name: 'FarbigkeitSquare',
  props: {
    value: { type: [String, Number], default: '' },
    color: { type: [String, Number], default: '' }
  },
  computed: {
    raw() {
      const v = String(this.value || this.color || '').toLowerCase().trim()
      return v.replace(/\s+/g, '')
    },
    is44()      { return /^4\/4|^4c|^4-?farb|^4f/.test(this.raw) },
    is41()      { return /^4\/1|^4\/0|^4\+1/.test(this.raw) },
    is11()      { return /^1\/1|^1\/0|^sw|^s\/w|^1c|^1f/.test(this.raw) },
    isSpecial() { return /sonder|pms|pantone|hks/.test(this.raw) },
    label() {
      if (this.is44)      return '4/4'
      if (this.is41)      return '4/1'
      if (this.is11)      return '1/1'
      if (this.isSpecial) return 'S'
      return this.raw ? '·' : ''
    },
    cls() {
      if (this.is44)      return 'farb-44'
      if (this.is41)      return 'farb-41'
      if (this.is11)      return 'farb-11'
      if (this.isSpecial) return 'farb-special'
      return 'farb-default'
    },
    title() {
      if (this.is44)      return '4/4 farbig (CMYK Schön + Wider)'
      if (this.is41)      return '4/1 (Farbe + Schwarz)'
      if (this.is11)      return '1/1 (Schwarzweiss)'
      if (this.isSpecial) return 'Sonderfarben'
      return this.raw || 'Farbigkeit unbekannt'
    }
  }
}
</script>

<style scoped>
.farb-square {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 22px;
  border-radius: 4px;
  font-size: 0.68rem;
  font-weight: 700;
  color: #fff;
  border: 1px solid rgba(0,0,0,0.18);
  text-shadow: 0 1px 1px rgba(0,0,0,0.35);
  letter-spacing: -0.02em;
  flex-shrink: 0;
}
.farb-44      {
                /* CMYK as an explicit 2×2 grid — reads C M / Y K:
                   top-left Cyan, top-right Magenta, bottom-left Yellow, bottom-right Key (black) */
                background-color: #00b6e4;
                background-image:
                  linear-gradient(#00b6e4, #00b6e4),
                  linear-gradient(#e6007e, #e6007e),
                  linear-gradient(#ffd200, #ffd200),
                  linear-gradient(#1d1d1b, #1d1d1b);
                background-size: 50% 50%;
                background-position: top left, top right, bottom left, bottom right;
                background-repeat: no-repeat; }
.farb-41      { background: linear-gradient(90deg,#e30613 0 50%,#1d1d1b 50% 100%); }
.farb-11      { background: #4a4a4a; }
.farb-special { background: #ff8c00; }
.farb-default { background: #c0c0c0; color: #555; text-shadow: none; }
</style>
